export default "__VITE_ASSET__CfA$Dme1__"